export default __webpack_public_path__ + "static/corporate-governance-banner-439c038b66f5fd5d342e4758a2fb2d43.png";